import { render, staticRenderFns } from "./NoSideProfile.vue?vue&type=template&id=06179590"
import script from "./NoSideProfile.vue?vue&type=script&lang=js"
export * from "./NoSideProfile.vue?vue&type=script&lang=js"
import style0 from "./NoSideProfile.vue?vue&type=style&index=0&id=06179590&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports